import { adminMarketingQueryKeys as e } from "./adminMarketingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminMarketingApi as n } from "@maat/api-main";
//#region src/marketing/admin/useAdminMarketingAssetQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.get(r),
	enabled: !!r
});
//#endregion
export { r as useAdminMarketingAssetQuery };
